<mat-tree [dataSource]="dataSource" [trackBy]="trackByFn" [treeControl]="treeControl" [ngStyle]="currentPage==='traduzioni' || currentPage==='ricerca' ? {background: '#e6edec'} : {}">
    <mat-tree-node [ngClass]="currentPage" *matTreeNodeDef="let node" matTreeNodePadding matTreeNodePaddingIndent="20">
        <button mat-icon-button disabled></button>
        
        <mat-checkbox disableRipple=true type="checkbox" *ngIf="currentPage === 'utenti'"
            [checked]="node.id | checkAssignedResource : assignedList" (change)="onCheckChange(node, $event.checked)">
        </mat-checkbox>
        <span [innerHTML]="node.index + ' - '  + node.title | safeHtml" *ngIf="currentPage === 'utenti'"></span>

        <mat-checkbox disableRipple=true type="checkbox" *ngIf="currentPage === 'ricerca'">
        </mat-checkbox>
        <span [innerHTML]="node.index + ' - '  + node.title | safeHtml" *ngIf="currentPage === 'ricerca'"></span>

        <span [innerHTML]="node.index + ' - ' + node.title | safeHtml" *ngIf="currentPage === 'traduzioni'"
            (click)="onRowSelection(node)" [ngClass]="selectedResource ?(selectedResource.id | activeTreeNode : node.id):''"></span>
    </mat-tree-node>
    <mat-tree-node [ngClass]="currentPage" *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding
        matTreeNodePaddingIndent="20">
        <button mat-icon-button [attr.aria-label]="'toggle ' + node.filename" (click)="onToggleFromIcon(node)">
            <mat-icon class="mat-icon-rtl-mirror arrowIndex">
                {{node.expanded ? 'expand_more' : 'chevron_right'}}
            </mat-icon>
        </button>
        <mat-checkbox disableRipple=true type="checkbox" *ngIf="currentPage === 'utenti'"
            (change)="onCheckChange(node, $event.checked)" [checked]="node.id | checkAssignedResource : assignedList">
        </mat-checkbox>
        <span [innerHTML]="node.index + ' - ' + node.title | safeHtml" *ngIf="currentPage === 'utenti'"></span>

        <mat-checkbox disableRipple=true type="checkbox" *ngIf="currentPage === 'ricerca'">
        </mat-checkbox>
        <span [innerHTML]="node.index + ' - ' + node.title | safeHtml" *ngIf="currentPage === 'ricerca'"></span>

        <span [innerHTML]="node.index + ' - ' + node.title | safeHtml" *ngIf="currentPage === 'traduzioni'"
            (click)="onRowSelection(node)" [ngClass]="selectedResource ?(selectedResource.id | activeTreeNode : node.id):''"></span>
    </mat-tree-node>
</mat-tree>